import axios from 'axios';
import Message from '@/utils/resetMessage';
import { adapterAfterLoginNavigate } from '@/microAdapt/function'
import { router } from '@/router';
import { exitSystem } from "@/utils/generalMethods";
import logServeCof from '@/plugins/logServeCof.js';
import Vue from 'vue';

// 创建axios实例
const service = axios.create({
    baseURL: `${window.baseDataUrl}/${logServeCof.logServeCof()}/basic`,
    timeout: window.commonTimeout
})

service.interceptors.response.use(data => {
    if (data.status && data.status == 200 && data.data.status == 'error') {
        Message.error({ message: data.data.msg });
        return;
    }
    return data;
}, err => {
    if (err.response.status == 504 || err.response.status == 404) {
        Message.error({ message: '服务器错误，请稍候再试!' });
    } else if (err.response.status == 400) {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.details) {
            Message.error({ message: err.response.data.error.details });
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else if (err.response.status == 401) {
        Message.success({ message: '退出登录' });
        adapterAfterLoginNavigate(() => {
            if (window.isCloseTab) {
                exitSystem();
            } else {
                if (window.isPrivate) {
                    router.push('/privateLogin');
                } else {
                    router.push('/login')
                }
                window.location.reload()
            }
        });
    } else if (err.response.status == 403) {
        let response = err.response;
        let url = response.config.url;
        if (url.includes('logout')) {
            if (window.isPrivate) {
                router.push('/privateLogin');
            } else {
                router.push('/login')
            }
            window.location.reload()
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else {
        Message.error({ message: '未知错误!' });
    }
    return Promise.reject(err);
})

export default service;